import { ObjectMapper } from 'json-object-mapper';

export class StandardFieldVisibilityModel {
  fieldKey: string = '';
  name: string = '';
  order: number = 0;
  hidden: boolean = false;

  static create(input: Partial<StandardFieldVisibilityModel> = {}) {
    return ObjectMapper.deserialize<StandardFieldVisibilityModel>(StandardFieldVisibilityModel, input || {});
  }
}
